var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalculator = function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M3.054 4.995c0-2.662 2.137-4.87 4.834-4.87h24.224c2.697 0 4.834 2.208 4.834 4.87v30.01c0 2.662-2.137 4.87-4.834 4.87H7.888c-2.697 0-4.834-2.208-4.834-4.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    fillRule: "evenodd",
    d: "M7.34 4.995c0-.35.273-.585.548-.585h24.224c.276 0 .548.235.548.585v9.758H7.34z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "M11.397 7.24a.818.818 0 1 0-1.157 1.157L11.843 10l-1.603 1.603a.818.818 0 0 0 1.157 1.157L13 11.157l1.603 1.603a.818.818 0 0 0 1.158-1.157L14.157 10l1.604-1.603a.818.818 0 0 0-1.158-1.157L13 8.843zM18.397 7.24a.818.818 0 1 0-1.157 1.157L18.843 10l-1.603 1.603a.818.818 0 1 0 1.157 1.157L20 11.157l1.603 1.603a.818.818 0 0 0 1.157-1.157L21.158 10l1.604-1.603a.818.818 0 0 0-1.158-1.157L20 8.843zM25.397 7.24a.818.818 0 1 0-1.157 1.157L25.843 10l-1.603 1.603a.818.818 0 1 0 1.157 1.157L27 11.157l1.603 1.603a.818.818 0 0 0 1.157-1.157L28.158 10l1.604-1.603a.818.818 0 0 0-1.158-1.157L27 8.843z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    fillRule: "evenodd",
    d: "M10.94 24.912a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Zm9.06 0a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Zm11.203-2.143a2.143 2.143 0 1 1-4.286 0 2.143 2.143 0 0 1 4.286 0ZM10.94 34.127a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Zm11.202-2.143a2.143 2.143 0 1 1-4.286 0 2.143 2.143 0 0 1 4.286 0Zm6.917 2.143a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z",
    clipRule: "evenodd"
  })));
};
export default SvgCalculator;